import type { AiModelRecord } from "../../models/types.js";
import { normalizeString } from "./normalize.js";
import type { CatalogIndexes } from "./types.js";

export function buildCatalogIndexes(catalog: Map<string, AiModelRecord>): CatalogIndexes {
  const aliasIndex = new Map<string, string>();
  const slugIndex = new Map<string, string>();
  const prefixCounts = new Map<string, number>();

  for (const record of catalog.values()) {
    for (const alias of record.aliases) {
      aliasIndex.set(normalizeString(alias), record.modelId);
    }
    if (record.canonicalSlug) {
      slugIndex.set(normalizeString(record.canonicalSlug), record.modelId);
    }
    const pid = record.providerId;
    prefixCounts.set(pid, (prefixCounts.get(pid) ?? 0) + 1);
  }

  const providerPrefixesBySize = [...prefixCounts.entries()]
    .sort((a, b) => b[1] - a[1])
    .map(([p]) => p);

  return { aliasIndex, slugIndex, providerPrefixesBySize };
}
